import React from "react";
import {
  Datagrid,
  List,
  SimpleShowLayout,
  TextField,
  DateField,
  Filter,
  TextInput,
  BooleanInput,
  required, ReferenceField, NumberInput, NumberField, ReferenceInput, SelectInput, BooleanField,
} from "react-admin";
import ShowView from "../../components/ShowView";
import EditView from "../../components/EditView";
import CreateView from "../../components/CreateView";



const VariantFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput label="آزمایش " validate={required()} source="experimentId" reference="experiment">
      <SelectInput optionText="title" alwaysOn/>
    </ReferenceInput>
  </Filter>
);

export const VariantList = (props) => (
  <List {...props} filters={<VariantFilter/>} perPage={10}>
    <Datagrid rowClick="show">
      <TextField label="شناسه" source="objectId"/>
      <ReferenceField link="show" label="آزمایش" source="experimentId" reference="experiment">
        <TextField source="title" />
      </ReferenceField>
      <TextField  source="title"/>
      <NumberField label="وزن" source="weight"/>
      <BooleanField label="فعال" source="isActive"/>
    </Datagrid>
  </List>
);

export const VariantShow = (props) => (
  <ShowView {...props} noEdit={false}>
    <SimpleShowLayout>
      <TextField label="شناسه" source="objectId"/>

      <ReferenceField link="show" label="آزمایش" source="experimentId" reference="experiment">
        <TextField source="title" />
      </ReferenceField>

      <TextField  source="title"/>
      <NumberField label="وزن" source="weight"/>
      <BooleanField label="فعال" source="isActive"/>
      <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>

    </SimpleShowLayout>
  </ShowView>
);

export const VariantEdit = (props) => (
  <EditView {...props}>
    <TextField source="objectId"/>
    <ReferenceInput label="آزمایش " validate={required()} source="experimentId" reference="experiment">
      <SelectInput optionText="title" alwaysOn/>
    </ReferenceInput>
    <TextInput  source="title"/>
    <NumberInput label="وزن" source="weight"/>
    <BooleanInput label="فعال" source="isActive"/>
  </EditView>
);

export const VariantCreate = (props) => (
  <CreateView {...props}>
    <ReferenceInput label="آزمایش " validate={required()} source="experimentId" reference="experiment">
      <SelectInput optionText="title" alwaysOn/>
    </ReferenceInput>
    <TextInput  source="title"/>
    <NumberInput label="وزن" source="weight"/>
    <BooleanInput label="فعال" source="isActive"/>
  </CreateView>
);
